export default __webpack_public_path__ + "static/media/back-icon.ca9e26cb.svg";